import { Component, Input } from "@angular/core";
import { environment } from "src/environments/environment";

@Component({
  selector: "app-external-layout",
  templateUrl: "./external-layout.component.html",
})
export class ExternalLayoutComponent {
  @Input() loading: boolean = false;
  logo = environment.logo;
}
